export const API_DATE_REGEXP = /\d{4}-\d{2}-\d{2}/
